import { render, staticRenderFns } from "./SettingCard.vue?vue&type=template&id=aacb6422&scoped=true"
import script from "./SettingCard.vue?vue&type=script&lang=js"
export * from "./SettingCard.vue?vue&type=script&lang=js"
import style0 from "./SettingCard.vue?vue&type=style&index=0&id=aacb6422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacb6422",
  null
  
)

export default component.exports